module.exports = __webpack_public_path__ + "static/chairs.c3ae461f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/chairs.jpg
// module id = 443
// module chunks = 213534597649335